export class Constants {
  public static pageLimit = 100;
  public static pageOptions = [5, 10, 25, 100];

  public static userDetails = 'The module is display user details which can access admin panel.';
  public static contactDetails = 'The module is display contact/query listing which are requested by website users.';

  public static emailDetails = `The Email module is allow to add Email-template to a specific admin.
    We also provide facilities to add/edit and delete the particular email-template by admin.`;

  public static propertiesList = 'The module is display property listing which are requested by website users.';

}

const YES_NO_OPTIONS = ['Sí', 'No'];
const DOOR_OPTIONS = [
  { value: 'letters', label: 'Letra (A, B, C...)' },
  { value: 'numbers', label: 'Número (1, 2, 3...)' },
  { value: 'ingle_door', label: 'Puerta sencilla' },
  { value: 'left_side', label: 'Izquierda' },
  { value: 'right_side', label: 'Bien' },
  { value: 'exterior', label: 'Exterior' },
  { value: 'exterior_left', label: 'Exterior izquierdo' },
  { value: 'exterior_right', label: 'Exterior derecho' },
  { value: 'interior', label: 'Interior' },
  { value: 'interior_left', label: 'Interior izquierdo' },
  { value: 'interior_right', label: 'Interior derecho' },
  { value: 'center', label: 'Centro' },
  { value: 'center_left', label: 'Centro izquierda' },
  { value: 'center_right', label: 'Centro derecha' },
];

const STRUCTURE_TYPE_OPTIONS = ['Apartamento', 'Ático', 'Dúplex', 'Estudio/loft'];
const CONDITION_TYPE_OPTIONS = ['Necesita renovación', 'Buen estado', 'Nueva', 'Reformado', 'Muy bueno'];
const INTERIOR_TYPE_OPTIONS = ['Exterior', 'Interior'];
const FURNISHMENT_TYPE_OPTIONS = [
  'Cocina no equipada y vivienda sin muebles.',
  'Cocina totalmente equipada y vivienda sin amueblar.',
  'Cocina totalmente equipada y casa amueblada.'
];
const LEFT_TYPE_OPTIONS = ['Sí', 'No'];
const DIRECTION_OPTIONS = [
  'Norte',
  'Sur',
  'Este',
  'Oeste',
  'Noreste',
  'Noroeste',
  'Sureste',
  'Suroeste',
];
const FURNISHING_OPTIONS = [
  'Video Portero',
  'Garaje',
  'Vista al mar',
  'Domótica',
  'Aire Acondicionado',
  'Armarios empotrados',
  'Trastero',
  'Terraza'
];

const EMISSIONS_RATING = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G'
];

const ENERGY_CONSUMPTION_RATING = [
  { value: '', label: 'Elegir' },
  { value: 'UNKNOWN', label: 'No disponible aún' },
  { value: 'A', label: 'A' },
  { value: 'B', label: 'B' },
  { value: 'C', label: 'C' },
  { value: 'D', label: 'D' },
  { value: 'E', label: 'E' },
  { value: 'F', label: 'F' },
  { value: 'G', label: 'G' },
  { value: 'IN_PROCESS', label: 'En proceso' },
  { value: 'EXEMPT', label: 'Propiedad exenta' }
];

const VISIT_FREQUENCY_OPTIONS = ['Any time', '1 time a week', '2 times a week'];
const DAYSOPTIONS = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
const VISITION_OPTIONS = [
  { value: false, label: 'No' },
  { value: true, label: 'Yes' },
];

const CONTENT_TYPES = [
  { value: 'main_image', label: 'Main Image', },
  { value: 'sub_images', label: 'Sub Images' },
  { value: 'gallery', label: 'Gallery' },
  { value: 'description', label: 'Description' },
  { value: 'video', label: 'Video' },
];

const IMAGE_POSITION = ['left', 'right']; // image position
const BLOG_TYPE = ['header', 'middle', 'secondary'];

export {
  DOOR_OPTIONS, STRUCTURE_TYPE_OPTIONS, CONDITION_TYPE_OPTIONS,
  INTERIOR_TYPE_OPTIONS,
  FURNISHMENT_TYPE_OPTIONS,
  YES_NO_OPTIONS, DIRECTION_OPTIONS,
  FURNISHING_OPTIONS, ENERGY_CONSUMPTION_RATING, EMISSIONS_RATING,
  VISIT_FREQUENCY_OPTIONS, DAYSOPTIONS, VISITION_OPTIONS,
  CONTENT_TYPES, IMAGE_POSITION, BLOG_TYPE
};
